<template>
  <div
    class="user-row neumorphism-curved"
    :class="
      user.color == '#D2F5FF' || user.color == '#FFFFFF' ? 'text-color' : ''
    "
    v-bind:style="{
      background: `${user.color}`,
    }"
    @click="showUserHitoric"
  >
    <div class="user-row-image">
      <v-avatar v-if="user.details.imagePath" size="30">
        <base-64-to-image
          v-if="user.details.imagePath"
          :base64Image="user.details.imagePath"
          :alt="user.details.fullName"
        >
        </base-64-to-image>
      </v-avatar>
    </div>

    <div class="row-info">
      <div class="user-row-name flex-md-grow-1">
        {{ user.details.lastName }}
        {{ user.details.firstName | capitalize }}
      </div>

      <!-- <div
        v-if="$vuetify.breakpoint.lgAndUp && user.details.skills"
        class="user-row-name flex-md-grow-1"
      >
        {{ user.details.skills.slice(0, 10)[0] }}
      </div> -->
      <div
        class="user-row-city flex-lg-grow-1"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        {{ user.location | capitalize }}
      </div>
      <!-- <div class="user-row-company" v-if="$vuetify.breakpoint.lgAndUp">
        {{ user.details.company | capitalize }}
      </div> -->
    </div>
  </div>
</template>

<script>
import base64ToImage from "@/components/components-base/image/base64ToImage.vue";

export default {
  name: "user-row",
  props: { user: null },
  components: { base64ToImage },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    dateFormat: function (value) {
      if (value) {
        value = new Date(value);
        return value.getFullYear();
      }
    },
  },
  methods: {
    showUserHitoric() {
      this.$emit("show-user-hitoric", this.user.details.idDg2);
    },
  },
};
</script>

<style lang="scss">
.user-row {
  cursor: pointer;
  margin: 5px;
  border-left: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  font-weight: 600;
  width: 100%;
  height: var(--row-height);
  padding: 10px 5px;
  border-radius: 30px;
  font-size: 0.9rem;

  &:last-child {
    border: 5px 0 10px;
  }

  .user-row-image {
    width: 40px;
  }

  .user-row-city {
    text-align: right;
    padding: 0 10px 0 0;
  }

  .row-info {
    width: calc(100% - 40px);
    display: flex;

    & > span {
      margin: 0 5px;
    }
  }
}

.text-color {
  color: #111010;
}
</style>
